export const ReviewQuoteIcon = () => (
  <svg viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.86424 43.1831L13.0979 26.2063H6.90002L6.90002 6.39996L28.9969 6.39996L28.9969 26.6105L23.7421 43.1831H9.86424ZM38.9674 43.1831L42.2011 26.2063H36.1379V6.39996L58.1 6.39996V26.6105L52.98 43.1831H38.9674Z"
      fill="#FF6B4A"
    />
  </svg>
);
